import { IntlShape } from 'react-intl';
import * as Yup from 'yup';

export const surchargeValidation = (intl: IntlShape) =>
    Yup.object().shape({
        startDate: Yup.string()
            .required(intl.formatMessage({ defaultMessage: 'Start datum is verplicht' }))
            .nullable(),
    });
